import * as types from "../types/internetStatus"

export const setInternetStatus = isOnline => ({
  type: types.SET_INTERNET_STATUS,
  isOnline
})

export const setForceOffline = () => ({
  type: types.SET_FORCE_OFFLINE
})

export const removeForceOffline = () => ({
  type: types.REMOVE_FORCE_OFFLINE
})